import _ from 'lodash'
import tinycolor from 'tinycolor2'
import { VEHICLES_BUCKET } from './config'

export function vehicle_image_file( vif, color_name ){
    return `${VEHICLES_BUCKET}/${_.padStart(vif, 4, 0)}_cc0640_001_${color_name}.png`
}

export function sort_vehicle_colors(colors){
    return colors.map( color => _.assign(color, {
        hsl: tinycolor(color.rgb1).toHsl()
    }))
    .sort((a, b) => {
    	return ((360-a.hsl.h) + (a.hsl.s*2) + a.hsl.l) - ((360-b.hsl.h) + (b.hsl.s*2) + b.hsl.l)
	})
}

export function vehicle_unchanged(current_vehicle, new_vehicle){
    return (current_vehicle.make === new_vehicle.make) && (current_vehicle.model === new_vehicle.model) && (current_vehicle.year === new_vehicle.year)
}

export function vehicle_changed(current_vehicle, new_vehicle){
    return !vehicle_unchanged(current_vehicle, new_vehicle)
}

export function vehicle_has_colors(vehicle){
	return vehicle.image.colors && vehicle.image.colors.length
}

export class Vehicle{
    constructor(values){
        _.assign(this, values)
        if( this.has_colors() ){
            this.image.colors = sort_vehicle_colors(this.image.colors)
        }
        this.is_ok = this.is_vehicle_ok()
        this.is_image_available = this.has_image()
        this.is_colors_available = this.has_colors()
        this.visible = this.should_show()

        if( !values.current_color ){
            this.current_color = this.is_image_available ? this.image.colors[0] : {}
        }
        if( this.image ){
            this.image.url = this.current_color.image
        }
    }
    get_image(color_code){
        if( this.is_image_available ){
            return vehicle_image_file(this.image.vif, color_code)
        }else{
            return null
        }
    }
    set_color(color){
        this.image.url = color.image
        return this
    }
    is_vehicle_ok(){
        return !!(this.make && this.model && this.year && (this.size || this.diameter))
    }
    is_different_from(new_vehicle){
        return !vehicle_unchanged(this, new_vehicle)
    }
    has_image(){
        return !!this.image && this.has_colors()
    }
    has_colors(){
        return !!(this.image && this.image.colors && this.image.colors.length)
    }
    should_show(){
        return !!(this.has_image() && this.has_colors())
    }
}
